<pp-radio
  [ppDisabled]="ppDisabled()"
  [ppChecked]="doesNotRepeat"
  (click)="removeEndDate()"
  ppStyle="blue"
  >{{ 'repeat_forever' | ppTranslate }}</pp-radio
  >
  <pp-radio
    [ppDisabled]="ppDisabled()"
    [ppChecked]="!doesNotRepeat"
    (click)="allowSettingEndDate()"
    ppStyle="blue"
    >{{ 'end_date' | ppTranslate }}</pp-radio
    >

    <pp-datepicker
      [ppDisabled]="doesNotRepeat || ppDisabled()"
      data-test="dateSelect"
      class="pointReminderEndDatePicker"
      [ppDate]="ppEndDate()"
      (ppSelect)="onEndDateChange($event)"
      [ppShowCalendarIcon]="true"
      [ppMinDate]="ppMinDate().getTime()"
    ></pp-datepicker>

    @if (showDateWarning()) {
      <div class="timeWarning">
        <pp-icon
          [ppSrc]="EIconPath.ICON_BADGE_WARNING_14"
          ppColor="inherit"
          class="timeWarning__icon"
          ppClass="setSize14"
        ></pp-icon>
        {{ 'reminder_end_date_warning' | ppTranslate }}
      </div>
    }
